import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
import {
    normalizeTeamApiError,
    normalizeTeamApiResponse,
} from "./normalizeTeamApiResult";

export const addTeam = async (newTeam) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.post(
            `${FIRMFLOWURL}api/Team`,
            {
                ...newTeam,
            },
            {
                headers: { Authorization: token },
            }
        );

        return normalizeTeamApiResponse(response, "Unable to create team.");
    } catch (err) {
        console.log(err);
        if (err?.response?.status === 401 || err?.message?.includes("401")) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return;
        }

        return normalizeTeamApiError(err, "Unable to create team.");
    }
};
